'use client';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import type { SxProps } from '@mui/system';
import { useState } from 'react';
import type { ShowMoreToggleProps } from '.';

export type ShowMoreToggleClientProps = {
  children?: React.ReactNode;
} & ShowMoreToggleProps;

export function ShowMoreToggleClient({
  children,
  height = '200',
  showMoreText = 'Show more',
  showLessText = 'Show less',
}: ShowMoreToggleClientProps) {
  const [isFullyExpanded, setisFullyExpanded] = useState(false);

  const onShowMoreClick = () => {
    setisFullyExpanded(!isFullyExpanded);
  };

  const afterStyles: SxProps = {
    position: 'absolute',
    background: 'linear-gradient(hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, 0.5))',
    bottom: 0,
    height: '50%',
    content: '""',
    left: 0,
    right: 0,
  };

  const afterExpandedStyles: SxProps = {
    background: 'none',
    position: 'relative',
  };

  const baseStyles: SxProps = {
    overflow: 'hidden',
    position: 'relative',
    height: isFullyExpanded ? '100%' : `${height}px`,
    '& p:first-of-type': { marginTop: 0 },
    '&::after': isFullyExpanded ? afterExpandedStyles : afterStyles,
  };

  return (
    <>
      <Box sx={{ ...baseStyles }}>{children}</Box>
      <Link
        component="button"
        onClick={onShowMoreClick}
        sx={{
          cursor: 'pointer',
          display: 'inline-flex',
          gap: '0.1rem',
          alignItems: 'center',
          '&:hover': {
            textDecoration: 'none',
            fontWeight: 500,
          },
        }}
      >
        {isFullyExpanded ? showLessText : showMoreText}{' '}
      </Link>
    </>
  );
}
